export default "__VITE_ASSET__DhKXCreY__"